export default __webpack_public_path__ + "static/ZawemaMini-bc2ecf8810b7f99b14ceae936241d98e.png";